/**
 * localStorage 封装
 */
import { STORAGE_KEYS } from '../config.js';

export const storage = {
  /**
   * 获取 Token
   */
  getToken(): string | null {
    return localStorage.getItem(STORAGE_KEYS.TOKEN);
  },

  /**
   * 设置 Token
   */
  setToken(token: string): void {
    localStorage.setItem(STORAGE_KEYS.TOKEN, token);
  },

  /**
   * 清除 Token
   */
  clearToken(): void {
    localStorage.removeItem(STORAGE_KEYS.TOKEN);
  },

  /**
   * 获取 Chat JID
   */
  getChatJid(): string | null {
    return localStorage.getItem(STORAGE_KEYS.CHAT_JID);
  },

  /**
   * 设置 Chat JID
   */
  setChatJid(jid: string): void {
    localStorage.setItem(STORAGE_KEYS.CHAT_JID, jid);
  },

  /**
   * 清除 Chat JID
   */
  clearChatJid(): void {
    localStorage.removeItem(STORAGE_KEYS.CHAT_JID);
  },

  /**
   * 获取主题
   */
  getTheme(): 'light' | 'dark' {
    const theme = localStorage.getItem(STORAGE_KEYS.THEME);
    return theme === 'light' || theme === 'dark' ? theme : 'dark';
  },

  /**
   * 设置主题
   */
  setTheme(theme: 'light' | 'dark'): void {
    localStorage.setItem(STORAGE_KEYS.THEME, theme);
    document.body.setAttribute('data-theme', theme);
  },
};
